import React from 'react'


export default function SignupData(props: any) {
  const signup_data = props.signup_data

  return <div>
    {
      Object.keys(signup_data).map(k => {
        const d = signup_data[k]
        if (typeof (d) === 'string') {
          if (!Boolean(d)) return <div key={k} />
        } else if (typeof (d) === 'object') {
          if (Object.keys(d).length === 0) return <div key={k} />
        }

        return <div key={k}>
          <strong>{k}: </strong>
          <span style={{ whiteSpace: 'pre-line' }}>
            {typeof (d) === 'string' ?
              d
              :
              JSON.stringify(signup_data[k])
            }
          </span>
        </div>
      })
    }
  </div>
}